import React, { ChangeEvent, ChangeEventHandler, CSSProperties } from 'react';
import { TouchableOpacity } from 'react-native';
import useFontSize from '../../shell/hooks/useFontSize';

interface CheckboxProps {
    label: string;
    style?: CSSProperties,
    checked: boolean,
    onCheck: () => void;
}

export const Checkbox: React.FC<CheckboxProps> = ({ label, onCheck, checked, style }) => {

    const checkboxContainer: React.CSSProperties = {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        width: "fit-content"
    };

    const checkboxInput: React.CSSProperties = {
        display: 'none',
    };

    const checkboxLabel: React.CSSProperties = {
        display: 'inline-block',
        width: 20,
        height: 20,
        border: '1px solid #ddd',
        borderRadius: 2,
        backgroundColor: checked ? '#ff69b4' : 'transparent',
        marginRight: 8,
        position: 'relative',
    };

    const checkboxCustom: React.CSSProperties = {
        position: 'absolute',
        display: checked ? 'block' : 'none',
        top: 3,
        left: 5,
        fontSize: 16,
        color: '#fff',
    };
    const checkboxText = {
        zIndex: 1,
        fontFamily: "Ink Free",
        fontSize: useFontSize(3),
        fontWeight: "bold",
        color: "white",
        margin: 0,
        textAlign: "center",
        textShadowColor: "#E91E63",
        textShadowRadius: 4,
        textShadowOffset: { width: 2, height: 2 },
    };

    return (


        <div onClick={() => {
            onCheck();
        }} style={checkboxContainer}>
            <input
                type="checkbox"
                style={checkboxInput}
                onChange={() => { }}
                checked={checked}

            />
            <label style={{ ...checkboxLabel }}>
                <span style={{ ...checkboxCustom }}>
                    <i className="fa fa-check"></i>
                </span>
            </label>
            <p style={{ ...checkboxText as CSSProperties, ...style }}>

                {label}
            </p>
        </div>
    );
};

